var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 60,
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 75.2432L27.6666 85.2972",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6666 75.2436V61.8382C67.6666 59.9949 66.1666 58.4868 64.3333 58.4868H26C24.1666 58.4868 22.6666 59.9949 22.6666 61.8382V86.9733C22.6666 88.8165 24.1666 90.3246 26 90.3246H64.3333C66.1666 90.3246 67.6666 88.8165 67.6666 86.9733V80.2706",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6666 63.5137L49.3333 76.9191C47.3 78.4942 43.0333 78.4942 41 76.9191L27.6666 63.5137",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6666 75.2432L62.6666 85.2972",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 48.4326L64.3333 53.4596",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3333 51.7837V58.4864",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6666 63.5136H95.9999C97.8333 63.5136 99.3333 62.0055 99.3333 60.1623V35.0271C99.3333 33.1839 97.8333 31.6758 95.9999 31.6758H57.6666C55.8333 31.6758 54.3333 33.1839 54.3333 35.0271V48.4325",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3333 36.7026L80.9999 50.108C78.9666 51.6832 74.6999 51.6832 72.6666 50.108L59.3333 36.7026",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3333 48.4326L94.3333 58.4867",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3333 48.4326H41",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 40.0542H26",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3333 31.6758H32.6666",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3333 83.6216H90.9999",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6666 75.2432H79.3333",
    stroke: "#21AEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsent);
export default __webpack_public_path__ + "static/media/emailsent.91947e927097e87313a6b2336c675bfc.svg";
export { ForwardRef as ReactComponent };